module.exports = __webpack_public_path__ + "static/img/TZ.79730615.jpg";